import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import EventEditorFormDefault from './EventEditorFormDefault'
import EventEditorFormPrisma from './EventEditorFormPrisma'

export default function EventFrom(props) {
  const [category, setCategory] = useState(props.event.category)
  const showProductForm = useMemo(() => category === 'product', [category])
  return showProductForm ? (
    <EventEditorFormPrisma {...props} onCategoryChanged={setCategory} category={category} />
  ) : (
    <EventEditorFormDefault {...props} onCategoryChanged={setCategory} category={category} />
  )
}

EventFrom.propTypes = {
  event: PropTypes.object,
  postUpdatedEvent: PropTypes.func,
  renderFormButtons: PropTypes.func,
  onFormChanged: PropTypes.func,
}
